<agr-dialog [data]="data" (confirm)="confirm()" (cancel)="cancel()">
  <div class="dialog spacing--margin-top">
    <div data-test="editTreatment-editForm" [formGroup]="formGroup" class="text--label">
      <div class="flex--row flex--gutter flex--nowrap">
        <div class="flex__child">
          <div class="flex--gutter">
            <div class="flex__child flex--row flex--gutter no-vertical-padding flex--nowrap">
              <div class="flex__child--auto">
                <mat-form-field class="full-width-field flex__child">
                  <mat-label>{{
                    'sharedTransport.table.headers.fertilizer' | translate
                  }}</mat-label>
                  <textarea
                    type="text"
                    style="resize: none"
                    matInput
                    formControlName="cropAidId"
                    [matAutocomplete]="editProductAutocomplete"
                    #newProductInput
                    data-test="editTreatment-productFilter"
                  ></textarea>
                  <mat-autocomplete
                    #editProductAutocomplete="matAutocomplete"
                    [displayWith]="displayProduct()"
                  >
                    @for (option of filteredCropAids$ | async; track option) {
                      <mat-option [value]="option.id" data-test="editTreatment-productOption">
                        {{ option.name }}
                        {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="flex__child--auto">
                <mat-form-field class="full-width-field flex__child comment__input">
                  <mat-label>
                    {{ 'comments' | translate }}
                  </mat-label>
                  <textarea
                    matInput
                    formControlName="comment"
                    data-test="editTreatment-comments"
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="flex__child flex--row flex--gutter flex--nowrap">
                <div class="flex__child max-width-container">
                  <mat-form-field class="full-width-field">
                    <mat-label>{{ 'period' | translate }}</mat-label>

                    <mat-select formControlName="periodId" data-test="editTreatment-period-id">
                      @for (period of salesOrderPeriods$ | async; track period) {
                        <mat-option [value]="period.id">
                          {{ period.name }} ({{ period.startDispatchFrom | agrDate: 'shortDate' }}
                          {{ 'until' | translate }}
                          {{ period.deliverBefore | agrDate: 'shortDate' }})
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex__child max-width-container">
                <mat-form-field class="full-width-field">
                  <mat-label>
                    {{ 'sharedTransport.table.headers.amountInTon' | translate }}
                  </mat-label>
                  <input
                    matInput
                    formControlName="dosage"
                    agrNumber
                    data-test="editTreatment-productDosage"
                    [step]="0.1"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="flex__child max-width-container">
                <mat-form-field class="full-width-field">
                  <mat-label>
                    {{ 'sharedTransport.table.headers.nitrogenInKg' | translate }}</mat-label
                  >
                  <input
                    matInput
                    formControlName="totalNitrogen"
                    agrNumber
                    [placeholder]=""
                    data-test="editTreatment-totalNitrogen"
                    [step]="1"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="flex__child max-width-container">
                <mat-form-field class="full-width-field">
                  <mat-label>
                    {{ 'sharedTransport.table.headers.phosphateInKg' | translate }}</mat-label
                  >
                  <input
                    matInput
                    formControlName="totalPhosphate"
                    agrNumber
                    [placeholder]=""
                    data-test="editTreatment-totalPhosphate"
                    [step]="1"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="vzc-form-action-buttons">
    <button mat-button (click)="closeDialog()">{{ 'cancel' | translate }}</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!formGroup.valid"
      class="vzc-save-button"
      (click)="confirmTransportEdit()"
      cdkFocusInitial
    >
      {{ 'save' | translate }}
    </button>
  </div>
</agr-dialog>
